/**
 * O nome do fornecedor como a pessoa lê (#6699): a API manda em caixa alta
 * («CONSULTOR KLABIN») e o card mostra nome próprio («Consultor Klabin»). Só
 * normaliza o que veio TODO em caixa alta — um nome que já tem minúscula
 * («RadioTáxi Premium») é do jeito que o fornecedor escreve. Siglas conhecidas
 * ficam em caixa alta, palavras com dígito ou ponto («S.A.», «99») ficam como
 * vieram, e as preposições do meio ficam minúsculas («Rádio Táxi de Guarulhos»).
 * Serve à lista de opções e ao 1-Click da corrida.
 */

const ACRONYMS = new Set([
  'VOLL',
  'SA',
  'S/A',
  'ME',
  'EPP',
  'EIRELI',
  'MEI',
  'VIP',
  'BH',
  'SP',
  'RJ',
  'DF',
  'ABC',
  'GRU',
  'CGH',
  'GIG',
  'SDU',
  'CNF',
  'BSB',
]);

const PARTICLES = new Set(['DE', 'DA', 'DO', 'DAS', 'DOS', 'E']);

function properWord(word: string, index: number): string {
  if (ACRONYMS.has(word) || /[\d.]/.test(word)) return word;
  if (index > 0 && PARTICLES.has(word)) return word.toLowerCase();
  const lower = word.toLocaleLowerCase('pt-BR');
  return lower.charAt(0).toLocaleUpperCase('pt-BR') + lower.slice(1);
}

export function supplierDisplayName(name: string): string {
  if (name !== name.toLocaleUpperCase('pt-BR')) return name;
  return name
    .split(/(\s+|-)/)
    .map((part, index) => (/^(\s+|-)$/.test(part) ? part : properWord(part, index)))
    .join('');
}
